export default "__VITE_ASSET__a83f4af6__"